import React from "react";
import { Icon } from "@iconify/react";

const InlineLoader = () => {
  return <Icon icon="svg-spinners:90-ring-with-bg" />;
};

export default InlineLoader;
